import React, { useEffect, useState } from "react";
import couponModel from "../../model/coupon.model";
import { HiMiniTag } from "react-icons/hi2";
import { IoCloseCircle } from "react-icons/io5";
import cartModel from "../../model/cart.model";
import { toast } from "../../lib/helper";
import AOS from "aos";
import "aos/dist/aos.css";
import back from "../../Asset/product/back.png";

const CoupleCode = ({ newSummery,setNewSummery,couponCode, setCouponCode,Validatecouple,couponOn,setCouponOn }) => {
  const [couponlist, setCouponlist] = useState();
  const [indexNo, setIndexNo] = useState(null);
  
  

  const GetCouponCode = async () => {
    couponModel
      .GetList()
      .then((responce) => {
        setCouponlist(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    GetCouponCode();
  }, []);

   useEffect(() => {
      AOS.init();
    }, []);

  return (
    <div className="w-full flex flex-col">
      <div className="w-full">
        <span className="text-textColor font-semibold text-base title1">
          Coupon Code
        </span>
      </div>
      <div
        className={`mt-4 bg-[#F6F7F3]   rounded-2xl px-4 py-4 flex flex-col md:flex-row gap-1 md:gap-4 justify-between items-center cursor-pointer`}
      >
        <input
          type="text"
          className="w-full  px-2 py-2 border-2 rounded-xl"
          placeholder="Enter Coupon Code"
          value={couponCode}
          onChange={(e) => {
            setCouponCode(e.target.value);
          }}
        />{" "}
        <button
          className="bg-textColor text-white px-4 py-3 md:py-2 text-[12px] rounded-3xl w-full md:w-20"
          onClick={() => {
            if(newSummery){
              setNewSummery("");
              setCouponCode("");
              setIndexNo(null);
            }else{
            Validatecouple();}
          }}
        >
          {newSummery ? "Remove" : "Apply"}
        </button>
        <button
          className="bg-textColor text-white px-4 text-[12px] py-3 md:py-2 rounded-3xl w-full md:w-20"
          onClick={() => {
            setCouponOn(true);
          }}
        >
          Select
        </button>
      </div>
      {couponOn && (
        <div
          className="w-full  bg-black/50 fixed inset-0 z-50 flex justify-center items-center"
          onClick={() => {
            setCouponOn(false);
          }}
        >
          <div
            className="bg-Background1 p-5 w-full md:w-1/2 h-4/5 rounded-3xl "data-aos="flip-up"  style={{
        backgroundImage: `url(${back})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
      }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="flex justify-between mb-5">
              <span className="text-lg text-textColor "
              style={{ fontFamily: "Salsa, sans-serif" }}>
                Select Coupon Code
              </span>
              <span className="text-3xl">
                <IoCloseCircle
                  className="cursor-pointer"
                  onClick={() => {
                    setCouponOn(false);
                  }}
                />
              </span>
            </div>
            <div className="p-4 w-full h-4/5 overflow-auto">
              {couponlist?.map((item, index) => {
                return (
                  <div
                    className={`mt-4 hover:bg-Background6 ${
                      index == indexNo && newSummery ? "bg-Background6" : "bg-white"
                    } rounded-2xl px-4 py-3 flex gap-2 justify-between items-center cursor-pointer`}
                    key={index}
                  >
                    <div className="flex flex-col gap-3 w-full  text-textColor">
                      <div className="flex gap-4 text-lg items-center text-green-600">
                        <HiMiniTag />
                        <span className="text-gray-800 title1 text-base">{item?.code}</span>
                      </div>
                      <span className="text-sm text-green-600">
                        Offer Applied ! ₹{item?.discount} is reduced from ₹
                        {item?.minimum_cart_value}
                      </span>
                    </div>
                    <div>
                      <button
                        className="bg-textColor text-white w-24 rounded-xl py-1 font-semibold hover:bg-gray-400"
                        onClick={() => {
                          if (index !== indexNo) {
                            setIndexNo(index);
                            setCouponCode(item?.code);
                            setCouponOn(false);
                          } else {
                            setNewSummery(null);
                            setIndexNo(null);
                            setCouponCode("");
                          }
                        }}
                      >
                        { index == indexNo && newSummery ? "Remove" : "Apply"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CoupleCode;
